class Card {
    constructor(suit, value) {
        this.suit = suit; // 'oros', 'copas', 'espadas', 'bastos'
        this.value = value; // 1-7, 10-12
        this.isFaceUp = false; // Default to face down
    }

    flip() {
        this.isFaceUp = !this.isFaceUp;
    }

    get imagePath() {
        // Assuming assets are stored in a standard way, e.g., assets/cards/oros_1.png
        // We might need to adjust this based on actual asset structure
        return `assets/cards/${this.suit}_${this.value}.png`;
    }

    toString() {
        return `${this.value} de ${this.suit}`;
    }
}

export default Card;
